import ROUTE_DEFAULTS from './defaults';
import RequestStatusTitle from '@/js/enums/RequestStatusTitle';
import { STATUS_CHIP_NAME } from './state';

const MAX_LABELS = 2;
const PSEUDO_LABELS = { new: 'Новые', overdue: 'Просроченные' };

function routeDefaults(method) {
    return ROUTE_DEFAULTS[method] || {};
}

export function effectiveStatuses(state) {
    if (state.statuses !== null) return state.statuses;
    return routeDefaults(state.method).statuses || [];
}

export function effectiveScope(state) {
    if (state.scope !== null) return state.scope;
    return routeDefaults(state.method).scope || 'all';
}

// Панель фильтров вправе менять только те статусы, под которые в ней есть поля.
// «Новые» — псевдостатус из панели статистики, поля у него нет вовсе; поля статуса
// и просрочки можно выключить в наборе. Всё, чем панель не управляет, переносим из
// текущего выбора, иначе применение панели молча сбрасывало бы то, что выбрано
// в панели статистики.
export function mergePanelStatuses(current, values) {
    const selected = current || [];
    const hasStatusField = Array.isArray(values.filterStatus);
    const hasExpiredField = values.filterExpired !== undefined;

    const statuses = [];

    if (selected.includes('new')) {
        statuses.push('new');
    }

    if (hasStatusField) {
        statuses.push(...values.filterStatus.map(Number));
    } else {
        statuses.push(...selected.filter((status) => status !== 'new' && status !== 'overdue'));
    }

    if (hasExpiredField ? Number(values.filterExpired) === 2 : selected.includes('overdue')) {
        statuses.push('overdue');
    }

    return statuses;
}

export function buildPayload(state) {
    const payload = { ...state.panel };

    const selected = effectiveStatuses(state);
    const statuses = selected.filter((s) => s !== 'overdue' && s !== 'new');
    const expired = selected.includes('overdue');
    const isNew = selected.includes('new');

    if (statuses.length > 0 || expired || isNew) {
        payload.filterStatusBar = { statuses, expired, isNew };
    }

    const scope = effectiveScope(state);
    if (scope && scope !== 'all') {
        payload.filterScope = scope;
    }

    return payload;
}

function statusesLabel(statuses) {
    if (!statuses.length) return 'Любой';

    const labels = statuses.map((s) => PSEUDO_LABELS[s] || RequestStatusTitle[s] || String(s));
    if (labels.length > MAX_LABELS) {
        return labels.slice(0, MAX_LABELS).join(', ') + ' +' + (labels.length - MAX_LABELS);
    }

    return labels.join(', ');
}

export function buildChips(state, { statusBarVisible }) {
    const chips = [...state.panelChips];

    // Дефолт раздела (statuses === null) — не условие; user-выбор виден чипом только
    // при скрытом ряде СТАТУС: при видимом ряде его показывает сам ряд.
    if (!statusBarVisible && state.statuses !== null) {
        chips.push({ name: STATUS_CHIP_NAME, title: 'Статус', label: statusesLabel(state.statuses) });
    }

    return chips;
}
